export default function () {
  this.sendEvent('support.open', {})
}
